import { IdentifySupplierJobsConstants } from "../constants/IdentifySupplierJobsConstants";
import { IdentifySupplierJobsServices } from "../services/IdentifySupplierJobsServices";
import Constants from "../constants/Constants";

export const IdentifySupplierJobsActions = {
  fetchGetLists,
  setPage,
  setSelectedList,
  setStatusDrawer,
  setSelectedRow,
  setFilters,
  setFiltersAndGetList,
  getCategories,
  getKeywords,
  getKeywordsFound,
  setStatusChangeList,
  getLocations,
  setUrls,
  setCrawlUrls,
  setOpenSnackbar,
  GetReasonsForDiscarded
};

function fetchGetLists(filters) {
  return (dispatch) => {
    dispatch(request());
    IdentifySupplierJobsServices.getList(filters).then(
      (data) => dispatch(success(data)),
      (error) => dispatch(failure(error))
    );
  };

  function request() {
    return {
      type: IdentifySupplierJobsConstants.FETCH_IDENTIFY_SUPPLIER_JOBS_RESULT_SET_RESULT_LIST_PENDING,
    };
  }

  function success(data) {
    return {
      type: IdentifySupplierJobsConstants.FETCH_IDENTIFY_SUPPLIER_JOBS_RESULT_GET_RESULT_LIST_SUCCESS,
      payload: data,
    };
  }

  function failure(error) {
    return {
      type: IdentifySupplierJobsConstants.FETCH_IDENTIFY_SUPPLIER_JOBS_RESULT_ERROR,
      error: error,
    };
  }
}

function setResultList(resultList) {
  return (dispatch) => {
    return dispatch(success(resultList));
  };

  function success(resultList) {
    return {
      type: IdentifySupplierJobsConstants.FETCH_IDENTIFY_SUPPLIER_JOBS_RESULT_SET_RESULT_LIST,
      payload: resultList,
    };
  }
}

function setPage(page) {
  return (dispatch) => {
    dispatch(request());
    dispatch(setSelectedList([]));
    return dispatch(success(page));
  };

  function request() {
    return {
      type: IdentifySupplierJobsConstants.FETCH_IDENTIFY_SUPPLIER_JOBS_RESULT_PENDING,
    };
  }

  function success(page) {
    return {
      type: IdentifySupplierJobsConstants.FETCH_IDENTIFY_SUPPLIER_JOBS_SET_PAGE,
      page: page,
    };
  }
}

function setSelectedList(selectedList) {
  return (dispatch) => {
    dispatch(success(selectedList));
  };

  function success(selectedList) {
    return {
      type: IdentifySupplierJobsConstants.FETCH_IDENTIFY_SUPPLIER_JOBS_SET_SELECTED_LIST,
      selectedList: selectedList,
    };
  }
}

function setStatusDrawer(statusDrawer) {
  return (dispatch) => {
    dispatch(request());
    return dispatch(success(statusDrawer));
  };

  function request() {
    return {
      type: IdentifySupplierJobsConstants.FETCH_IDENTIFY_SUPPLIER_JOBS_RESULT_PENDING,
    };
  }

  function success(statusDrawer) {
    return {
      type: IdentifySupplierJobsConstants.FETCH_IDENTIFY_SUPPLIER_JOBS_SET_STATUS_DRAWER,
      statusDrawer: statusDrawer,
      pending: statusDrawer,
    };
  }
}

function setSelectedRow(selectedRow) {
  return (dispatch) => {
    dispatch(request());
    dispatch(setStatusDrawer(true));
    return IdentifySupplierJobsServices.getDetails(selectedRow.IdIdentifySupplierJob).then(
      (data) => dispatch(success(data, selectedRow)),
      (error) => dispatch(failure(error))
    );
  };

  function request() {
    return {
      type: IdentifySupplierJobsConstants.FETCH_IDENTIFY_SUPPLIER_JOBS_RESULT_PENDING,
    };
  }

  function success(data, selectedRow) {
    return {
      type: IdentifySupplierJobsConstants.FETCH_IDENTIFY_SUPPLIER_JOBS_SET_SELECTED_ROW,
      selectedRow: selectedRow,
      selectedRowDetails: data,
    };
  }

  function failure(error) {
    return {
      type: IdentifySupplierJobsConstants.FETCH_IDENTIFY_SUPPLIER_JOBS_RESULT_ERROR,
      error: error,
    };
  }
}

function setFilters(filters) {
  return (dispatch) => {
    dispatch(request());
    return dispatch(success(filters));
  };

  function request() {
    return {
      type: IdentifySupplierJobsConstants.FETCH_IDENTIFY_SUPPLIER_JOBS_SET_FILTERS_PENDING,
    };
  }

  function success(filters) {
    return {
      type: IdentifySupplierJobsConstants.FETCH_IDENTIFY_SUPPLIER_JOBS_SET_FILTERS,
      filters: filters,
    };
  }
}

function setFiltersAndGetList(filters) {
  return (dispatch) => {
    dispatch(setSelectedList([]));
    dispatch(request());
    dispatch(success(filters));
    return dispatch(fetchGetLists(filters));
  };

  function request() {
    return {
      type: IdentifySupplierJobsConstants.FETCH_IDENTIFY_SUPPLIER_JOBS_SET_FILTERS_PENDING,
    };
  }

  function success(filters) {
    return {
      type: IdentifySupplierJobsConstants.FETCH_IDENTIFY_SUPPLIER_JOBS_SET_FILTERS,
      filters: filters,
      page: 0,
    };
  }
}

function getCategories(category) {
  return (dispatch) => {
    dispatch(request());
    IdentifySupplierJobsServices.getCategories(category).then(
      (data) => dispatch(success(data)),
      (error) => dispatch(failure(error))
    );
  };

  function request() {
    return {
      type: IdentifySupplierJobsConstants.FETCH_IDENTIFY_SUPPLIER_JOBS_GET_CATEGORIES_LIST_PENDING,
    };
  }

  function success(data) {
    return {
      type: IdentifySupplierJobsConstants.FETCH_IDENTIFY_SUPPLIER_JOBS_GET_CATEGORIES_LIST,
      categoryResult: data.data,
    };
  }

  function failure(error) {
    return {
      type: IdentifySupplierJobsConstants.FETCH_IDENTIFY_SUPPLIER_JOBS_RESULT_ERROR,
      error: error,
    };
  }
}

function getKeywords(keyword) {
  return (dispatch) => {
    dispatch(request());
    IdentifySupplierJobsServices.getKeywords(keyword).then(
      (data) => dispatch(success(data)),
      (error) => dispatch(failure(error))
    );
  };

  function request() {
    return {
      type: IdentifySupplierJobsConstants.FETCH_IDENTIFY_SUPPLIER_JOBS_GET_KEYWORDS_LIST_PENDING,
    };
  }

  function success(data) {
    return {
      type: IdentifySupplierJobsConstants.FETCH_IDENTIFY_SUPPLIER_JOBS_GET_KEYWORDS_LIST,
      keywordsResult: data.data,
    };
  }

  function failure(error) {
    return {
      type: IdentifySupplierJobsConstants.FETCH_IDENTIFY_SUPPLIER_JOBS_RESULT_ERROR,
      error: error,
    };
  }
}

function getKeywordsFound(keyword) {
  return (dispatch) => {
    dispatch(request());
    IdentifySupplierJobsServices.getKeywordsFound(keyword).then(
      (data) => dispatch(success(data)),
      (error) => dispatch(failure(error))
    );
  };

  function request() {
    return {
      type: IdentifySupplierJobsConstants.FETCH_IDENTIFY_SUPPLIER_JOBS_GET_KEYWORDS_FOUND_LIST_PENDING,
    };
  }

  function success(data) {
    return {
      type: IdentifySupplierJobsConstants.FETCH_IDENTIFY_SUPPLIER_JOBS_GET_KEYWORDS_FOUND_LIST,
      keywordsFoundResult: data.data,
    };
  }

  function failure(error) {
    return {
      type: IdentifySupplierJobsConstants.FETCH_IDENTIFY_SUPPLIER_JOBS_RESULT_ERROR,
      error: error,
    };
  }
}

function setStatusChangeList(resultList, statusChangeList, selectedList) {
  return (dispatch) => {
    dispatch(request());
    dispatch(setSelectedList(selectedList));

    IdentifySupplierJobsServices.postStatusChangeList(statusChangeList)
      .then(
        (data) => {
          dispatch(success(data.data.listToErrors));
          return data;
        },
        (error) => dispatch(failure(error))
      )
      .then((data) => {
        if (data.data.listToUpated != null && data.data.listToUpated.length > 0) {
          resultList.data = resultList.data.filter((item) => !data.data.listToUpated.some((x) => x.Key === item.IdIdentifySupplierJob));
          dispatch(setResultList(resultList));
        }

        return data;
      })
      .then((data) => {
        selectedList = selectedList.filter((item) => !data.data.listToUpated.some((x) => x.Key === item.IdIdentifySupplierJob));
        dispatch(setSelectedList(selectedList));
        return data;
      })
      .then((data) => {
        if (data.data.listToErrors != null && data.data.listToErrors.length > 0) {
          let typeAlert = Constants.ALERT_INFO;
          if (
            statusChangeList.IdStatus === Constants.SUPPLIER_JOB_STATUS_ENUM.Approved ||
            statusChangeList.IdStatus === Constants.SUPPLIER_JOB_STATUS_ENUM.Discarded
          ) {
            typeAlert = Constants.ALERT_WARNING;
          } else if (statusChangeList.IdStatus === Constants.ProcessAgain) {
            typeAlert = Constants.ALERT_ERROR;
          }
          dispatch(setOpenSnackbar(true, typeAlert));
        }
      });
  };

  function request() {
    return {
      type: IdentifySupplierJobsConstants.FETCH_IDENTIFY_SUPPLIER_JOBS_SET_STATUS_TO_JOB_LIST_PENDING,
    };
  }

  function success(listToErrors) {
    return {
      type: IdentifySupplierJobsConstants.FETCH_IDENTIFY_SUPPLIER_JOBS_SET_STATUS_TO_JOB_LIST,
      urls: listToErrors,
    };
  }

  function failure(error) {
    return {
      type: IdentifySupplierJobsConstants.FETCH_IDENTIFY_SUPPLIER_JOBS_RESULT_ERROR,
      error: error,
    };
  }
}

function getLocations() {
  return (dispatch) => {
    dispatch(request());
    IdentifySupplierJobsServices.getLocations().then(
      (data) => dispatch(success(data)),
      (error) => dispatch(failure(error))
    );
  };

  function request() {
    return {
      type: IdentifySupplierJobsConstants.FETCH_IDENTIFY_SUPPLIER_JOBS_RESULT_PENDING,
    };
  }

  function success(data) {
    return {
      type: IdentifySupplierJobsConstants.FETCH_IDENTIFY_SUPPLIER_JOBS_GET_LOCATIONS_LIST,
      locations: data.data,
    };
  }

  function failure(error) {
    return {
      type: IdentifySupplierJobsConstants.FETCH_IDENTIFY_SUPPLIER_JOBS_RESULT_ERROR,
      error: error,
    };
  }
}

function setUrls(urls) {
  return (dispatch) => {
    dispatch(request());
    IdentifySupplierJobsServices.postUrls(urls)
      .then(
        (data) => dispatch(success(data)),
        (error) => dispatch(failure(error))
      )
      .then((data) => {
        let openSnackbar = false;
        if (data != null && data.urls.length > 0) {
          openSnackbar = true;
        }
        dispatch(setOpenSnackbar(openSnackbar, Constants.ALERT_WARNING));
      });
  };

  function request() {
    return {
      type: IdentifySupplierJobsConstants.FETCH_IDENTIFY_SUPPLIER_JOBS_RESULT_PENDING,
    };
  }

  function success(data) {
    return {
      type: IdentifySupplierJobsConstants.FETCH_IDENTIFY_SUPPLIER_JOBS_SET_URL_LIST,
      urls: data.data,
    };
  }

  function failure(error) {
    return {
      type: IdentifySupplierJobsConstants.FETCH_IDENTIFY_SUPPLIER_JOBS_RESULT_ERROR,
      error: error,
    };
  }
}

function setCrawlUrls(urls) {
  return (dispatch) => {
    dispatch(request());
    IdentifySupplierJobsServices.postCrawlUrls(urls)
      .then(
        (data) => dispatch(success(data)),
        (error) => dispatch(failure(error))
      )
      .then((data) => {
        let openSnackbar = false;
        if (data != null && data.urls.length > 0) {
          openSnackbar = true;
        }
        dispatch(setOpenSnackbar(openSnackbar, Constants.ALERT_WARNING));
      });
  };

  function request() {
    return {
      type: IdentifySupplierJobsConstants.FETCH_IDENTIFY_SUPPLIER_JOBS_RESULT_PENDING,
    };
  }

  function success(data) {
    return {
      type: IdentifySupplierJobsConstants.FETCH_IDENTIFY_SUPPLIER_JOBS_SET_CRAWL_URL_LIST,
      urls: data.data,
    };
  }

  function failure(error) {
    return {
      type: IdentifySupplierJobsConstants.FETCH_IDENTIFY_SUPPLIER_JOBS_RESULT_ERROR,
      error: error,
    };
  }
}

function setOpenSnackbar(openSnackbar, typeAlert) {
  return (dispatch) => {
    return dispatch(success(openSnackbar));
  };

  function success(openSnackbar) {
    return {
      type: IdentifySupplierJobsConstants.FETCH_IDENTIFY_SUPPLIER_JOBS_SET_OPEN_SNACKBAR,
      openSnackbar: openSnackbar,
      typeAlert: typeAlert,
    };
  }
}

function GetReasonsForDiscarded() {
  return (dispatch) => {
    dispatch(request());
    IdentifySupplierJobsServices.GetReasonsForDiscarded().then(
      (data) => dispatch(success(data)),
      (error) => dispatch(failure(error))
    );
  };

  function request() {
    return {
      type: IdentifySupplierJobsConstants.FETCH_IDENTIFY_SUPPLIER_JOBS_GET_REASONSFORDISCARDED_LIST_PENDING,
    };
  }

  function success(data) {
    return {
      type: IdentifySupplierJobsConstants.FETCH_IDENTIFY_SUPPLIER_JOBS_GET_REASONSFORDISCARDED_LIST,
      reasonsForDiscarded: data.data,
    };
  }

  function failure(error) {
    return {
      type: IdentifySupplierJobsConstants.FETCH_IDENTIFY_SUPPLIER_JOBS_RESULT_ERROR,
      error: error,
    };
  }
}